import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop';
import PageViewTracker from './components/common/PageViewTracker';
import SiteLayout from './components/layout/SiteLayout';
import ToolsLandingPage2 from './pages/ToolsLandingPage2';
import ToolsPage from './pages/ToolsPage';
import DiagnosticPage from './pages/Diagnostic/DiagnosticPage';
import BudgetPlannerPage from './pages/BudgetPlanner/BudgetPlannerPage';
import CplCalculatorPage from './pages/CplCalculator/CplCalculatorPage';
import ProfitControlPage from './pages/ProfitControl/ProfitControlPage';
import BriefGeneratorPage from './pages/BriefGenerator/BriefGeneratorPage';
import UnitEconomicsPage from './pages/UnitEconomics/UnitEconomicsPage';
import BusinessCalculatorPage from './pages/BusinessCalculator/BusinessCalculatorPage';
import StartupCalculatorPage from './pages/StartupCalculator/StartupCalculatorPage';
import RevenueLeversPage from './pages/RevenueLevers/RevenueLeversPage';
import TargetAuditPage from './pages/TargetAudit/TargetAuditPage';
import ReportChecklistPage from './pages/ReportChecklist/ReportChecklistPage';
import ScaleCalculatorPage from './pages/ScaleCalculator/ScaleCalculatorPage';
import ChannelComparePage from './pages/ChannelCompare/ChannelComparePage';
import RomiTrackerPage from './pages/RomiTracker/RomiTrackerPage';
import MarketingDiagnosticPage from './pages/MarketingDiagnostic/MarketingDiagnosticPage';
import AudienceBuilderPage from './pages/AudienceBuilder/AudienceBuilderPage';
import AboutPage from './pages/About/AboutPage';
import ToolComingSoonPage from './pages/tools/ToolComingSoonPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
        <ScrollToTop />
        <PageViewTracker />
        <SiteLayout>
          <Routes>
            <Route path="/" element={<ToolsLandingPage2 />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/tools/startup-calculator" element={<StartupCalculatorPage />} />
            <Route path="/tools/business-calculator" element={<BusinessCalculatorPage />} />
            <Route path="/tools/economics-minimum" element={<UnitEconomicsPage />} />
            <Route path="/tools/cpl-calculator" element={<CplCalculatorPage />} />
            <Route path="/tools/profit-control" element={<ProfitControlPage />} />
            <Route path="/tools/revenue-levers" element={<RevenueLeversPage />} />
            <Route path="/tools/budget-planner" element={<BudgetPlannerPage />} />
            <Route path="/tools/brief-generator" element={<BriefGeneratorPage />} />
            <Route path="/tools/target-audit" element={<TargetAuditPage />} />
            <Route path="/tools/report-checklist" element={<ReportChecklistPage />} />
            <Route path="/tools/scale-calculator" element={<ScaleCalculatorPage />} />
            <Route path="/tools/channel-compare" element={<ChannelComparePage />} />
            <Route path="/tools/romi-tracker" element={<RomiTrackerPage />} />
            <Route path="/tools/marketing-diagnostic" element={<MarketingDiagnosticPage />} />
            <Route path="/tools/audience-builder" element={<AudienceBuilderPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/tools/:slug" element={<ToolComingSoonPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SiteLayout>
      </BrowserRouter>
  );
}

export default App;
